// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { VideoUrlType } from '../../../../types/Model';
import Dropup from '../Dropup';

interface ResolutionProps {
  urls?: VideoUrlType[];
  resolution: string;
  onResolutionChange: (resolution: string) => void;
}

const Resolution: React.FC<ResolutionProps> = props => {
  const {
    urls,
    resolution,
    onResolutionChange,
  } = props

  const resolutionOptions = urls ? urls.map((data) => data.type) : ['Auto'];

  const handleResolution = (nextQuality: string) => {
    onResolutionChange(nextQuality);
  }

  return (
    <Dropup
      options={resolutionOptions}
      handleChange={handleResolution}
      initialSelected={resolution}
    />
  )
}

export { Resolution as default }
